import { DocCepro } from '../../docs/components/DocCepro';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';
import { ManagerMenu } from '../../manager/managermenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';

const CeproDocNewPage = () => {
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.manager ? (
        <AppWrapper
          appType={APP_TYPE.MANAGER}
          menu={<ManagerMenu />}
          resource='RelatedApps'
          action='allow_manager_all'
        >
          <DocCepro />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default CeproDocNewPage;
